/* Unpublished design prototype. Replace with backend reservation expiry before release. */
(() => {
  const key = 'stilenza.cart.reservation-preview.deadline';
  class StilenzaCartTimer extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-cart-time]');
      this.drawer = this.closest('cart-drawer');
      if (!this.output || !this.drawer) return;
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearInterval(this.interval);
      this.interval = null;
    }

    sync() {
      clearInterval(this.interval);
      this.interval = null;
      if (!this.drawer.classList.contains('active')) return;
      try {
        const stored = Number(sessionStorage.getItem(key));
        this.deadline = Number.isFinite(stored) && stored > 0 ? stored : Date.now() + 600000;
        sessionStorage.setItem(key, String(this.deadline));
      } catch (_) {
        this.hidden = true;
        return;
      }
      this.update();
      if (!this.hidden) this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      if (this.deadline <= Date.now()) {
        this.deadline = Date.now() + 600000;
        try {
          sessionStorage.setItem(key, String(this.deadline));
        } catch (_) {
          this.hidden = true;
          clearInterval(this.interval);
          return;
        }
      }
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.hidden = seconds === 0;
      this.output.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      if (this.hidden) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }
  if (!customElements.get('stilenza-cart-timer')) customElements.define('stilenza-cart-timer', StilenzaCartTimer);
})();
